// const ProfilePage = () => import('./ProfilePage.vue');

import ProfilePage from "./ProfilePage.vue";

const routes = [
  {
    path: '/profile',
    name: 'profile',
    component: ProfilePage,
    meta: {
      title: 'Profile',
      requiresAuth: true,
      headerColor: '#4b4ced',
    }
  }
];

export default routes;
